import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "MaterialManagementService",
  controller: "MaterialManagement",
};

const methods = [
  "AddMaterialData",
  "UpdateMaterialData",
  "DelMaterialData",
  "GetMaterialDataList",
  "GetMaterialDataById"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function(data) {
      return this.post(path, data);
    };
  });
};

const MaterialManagementResourcesApi = ZJApi.defineNewApi("MaterialManagementResourcesApi", factory);

export default MaterialManagementResourcesApi;
